import {
  parseSlideDeckReadSource,
  type SlideDeckReadSource,
} from '@breakoutlearning/firebase-repository/cubits/slideDeckReadSource'
import { inE2E } from 'config/environment'

// sessionStorage key holding the slide-deck read source override. sessionStorage
// (not localStorage) scopes it to the single tab that set it — a CX user can
// compare v1 and v2 side by side in two tabs without one clobbering the other,
// and it clears when the tab closes. Set by the CX toggle; every subsequent page
// mount in that tab reads v2 (Adonis/Postgres) until it's cleared. Absent = the
// default v1 cloud function.
const STORAGE_KEY = 'slide-deck-source'

export function getSlideDeckReadSource(): SlideDeckReadSource | undefined {
  const stored = parseSlideDeckReadSource(sessionStorage.getItem(STORAGE_KEY))
  if (stored) return stored
  // e2e run-wide default: setting VITE_E2E_SLIDE_DECK_SOURCE=v2 on the web
  // server forces the whole suite onto the Adonis path without touching each
  // spec's localStorage. Only honored in e2e builds.
  if (inE2E()) {
    return parseSlideDeckReadSource(import.meta.env.VITE_E2E_SLIDE_DECK_SOURCE)
  }
  return undefined
}

export function setSlideDeckReadSource(
  source: SlideDeckReadSource | undefined
): void {
  if (source) sessionStorage.setItem(STORAGE_KEY, source)
  else sessionStorage.removeItem(STORAGE_KEY)
}
